import React from 'react'

export type MailLinkProps = {
    email: string
}

export function MailLink({ email }: MailLinkProps) {
    return <a href={`mailto:${email}`}>{email}</a>
}
